import React, { useRef } from "react";
import {
  formatTextareaCharacterCount,
  shouldAnnounceTextareaCharacterCount,
} from "@companion-core/shared/app/Components/Inputs/JPInput/jpInputTextareaA11y";

interface TextareaCharacterCountProps {
  count: number;
  maxLength?: number;
}

export const TextareaCharacterCount = ({
  count,
  maxLength,
}: TextareaCharacterCountProps): React.ReactElement => {
  const liveTextRef = useRef("");
  const visualCount = formatTextareaCharacterCount(count, maxLength);

  if (shouldAnnounceTextareaCharacterCount(count, maxLength)) {
    liveTextRef.current = visualCount;
  }

  return (
    <>
      <span aria-hidden="true">{visualCount}</span>
      <span aria-live="polite" aria-atomic="true" className="JPInputElement__sr-only">
        {liveTextRef.current}
      </span>
    </>
  );
};
